import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faInstagram,
  faGithub,
  faFacebookF,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';
library.add([faFacebookF,faInstagram,faGithub,faLinkedin]);
class Footer extends Component {
  render() {
    if (this.props.data) {
      var networks = this.props.data.social.map(function (network) {
        return (
          <li key={network.name}>
            <a href={network.url}>
              <FontAwesomeIcon icon={['fab', `${network.className}`]} />
            </a>
          </li>
        );
      });
    }

    return (
      <footer>
        <div className="row">
          <div className="twelve columns">
            <ul className="social-links">{networks}</ul>

            <ul>
              <li>with love K</li>
            </ul>

            <ul className="copyright">
              <li>&copy; Kerishma Tarin</li>

            </ul>
          </div>
          <div id="go-top">
            <a className="smoothscroll" title="Back to Top" href="#home">
              <i className="icon-up-open"></i>
            </a>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
